import * as Sentry from '@sentry/react';
import {createRoutesFromChildren, matchRoutes, Routes, useLocation, useNavigationType} from "react-router";
import { useEffect } from "react";


if(!import.meta.env.DEV) {

    Sentry.init({
        dsn: "https://5fc23922ef545d16e9647ca28e9bd4eb@o239846.ingest.us.sentry.io/4509202344771584",

        sendDefaultPii: true,

        integrations: [
            Sentry.reactRouterV7BrowserTracingIntegration({
                useEffect: useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),

            // Replay is only available in the client
            Sentry.replayIntegration({
                maskAllText: false,
                maskAllInputs: false,
            }),
        ],

        // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ["localhost", /^http:\/\/127\.0\.0\.2/],

        // Capture Replay for 10% of all sessions,
        // plus for 100% of sessions with an error
        // Learn more at
        // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    });
}

export const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes);